import { FC } from 'react'

import { Reservation } from 'src/types/reservation'

import ThirdPartyCallout from '../ThirdPartyCallout'
import OrderNumber from '../OrderNumber'
import StoreInfo from '../StoreInfo'
import PurchasedOn from '../PurchasedOn'
import CashFundDetails from '../CashFundDetails'

const FirstParty: FC<{ reservation: Reservation }> = ({ reservation }) => (
  <>
    <OrderNumber orderNumber={reservation.orderNumber} />
    <PurchasedOn
      createdAt={reservation.createdAt}
      purchasedAt={reservation.purchasedAt}
      storeName={reservation.storeName}
    />
  </>
)

const ThirdParty: FC<{ reservation: Reservation }> = ({ reservation }) => (
  <>
    <ThirdPartyCallout
      name={reservation.name as string}
      orderNumber={reservation.orderNumber}
    />
    <OrderNumber orderNumber={reservation.orderNumber} />
    <StoreInfo
      storeIdentifier={reservation.storeIdentifier}
      storeName={reservation.storeName}
    />
    <PurchasedOn
      createdAt={reservation.createdAt}
      purchasedAt={reservation.purchasedAt}
      storeName={reservation.storeName}
    />
  </>
)

const CashFund: FC<{ reservation: Reservation }> = ({ reservation }) => (
  <CashFundDetails
    createdAt={reservation.createdAt}
    paymentMethod={reservation.paymentMethod as string}
  />
)

const Favor: FC<{ reservation: Reservation }> = ({ reservation }) => (
  <PurchasedOn
    createdAt={reservation.createdAt}
    purchasedAt={reservation.purchasedAt}
    storeName={reservation.storeName}
  />
)

const PurchaseDetailsSection: FC<{ reservation: Reservation }> = ({
  reservation,
}) => {
  const isCashFund = !!reservation.paymentMethod
  if (isCashFund) {
    return <CashFund reservation={reservation} />
  }

  const { isFavor } = reservation.regItem
  if (isFavor) {
    return <Favor reservation={reservation} />
  }

  const isThirdParty = reservation.storeName !== 'Babylist'
  if (isThirdParty) {
    return <ThirdParty reservation={reservation} />
  }

  return <FirstParty reservation={reservation} />
}

export default PurchaseDetailsSection
